import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategoriesResolver } from '../places/resolvers/categories.resolver';
import { CitiesResolver } from '../places/resolvers/cities.resolver';
import { EventPageComponent } from './pages/event-page/event-page.component';
import { EventsPageComponent } from './pages/events-page/events-page.component';
import { EventsListResolver } from './resolvers/events-list.resolver';
import { EventPageResolver } from './resolvers/events-page.resolver';


const routes: Routes = [
  {
    path: '',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'event/:type/:username',
    component: EventPageComponent,
    resolve: { eventData: EventPageResolver }
  },
  {
    path: 'type/:type/:id',
    component: EventPageComponent,
    resolve: { eventData: EventPageResolver }
  },
  {
    path: 'category/:category',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'category/:category/sub-category/:subCategory',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city/category/:category/sub-category/:subCategory',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city/category/:category',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city/area/:area',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city/area/:area/category/:category/sub-category/:subCategory',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
  {
    path: 'city/:city/area/:area/category/:category',
    component: EventsPageComponent,
    resolve: { categories: CategoriesResolver, cities: CitiesResolver, events: EventsListResolver}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventsRoutingModule { }
